<template>
  <div>
    <api-errors :errors="errors" />
    <loading-bar v-if="awaitingApiResponse" />
    <v-card
      v-else-if="!filteredTables.length"
      class="ma-2 py-3"
    >
      <div class="text-center font-weight-bold">
        No Tables Available...
      </div>
    </v-card>
    <div v-else>
      <div>
        <v-row no-gutters>
          <v-spacer />
          <v-card
            class="pa-0 d-flex elevation-0"
            :disabled="(value.length || 0) > 1"
          >
            <label
              class="v-label d-flex align-self-center pr-1"
              style="cursor: pointer;"
              @click="allowSelectMultiple = !allowSelectMultiple"
            >
              Select Multiple
            </label>
            <v-simple-checkbox
              id="select-multiple-checkbox"
              :value="allowSelectMultiple"
              color="primary"
              :ripple="false"
              @input="allowSelectMultiple = !allowSelectMultiple"
            />
          </v-card>
        </v-row>
        <v-row
          no-gutters
          class="px-4"
        >
          <v-col cols="6">
            Table #
          </v-col>
          <v-col cols="6">
            Covers
          </v-col>
        </v-row>
        <template v-for="table in filteredTables">
          <table-card
            :key="'select-table-' + table.id"
            :table="table"
            no-overlay
            :selected="getTableSelected(table)"
            :allow-add="!getTableSelected(table)"
            :allow-remove="getTableSelected(table)"
            @click:add="selectTable(table)"
            @click:remove="selectTable(table)"
          >
            <template #adtl-content>
              <div
                :class="{
                  'red--text': getTableAssignments(table) > table.quantity,
                  'text--darken-1': getTableSelected(table)
                }"
              >
                {{ `${getTableAssignments(table)} of ${table.quantity}` }}
              </div>
            </template>
          </table-card>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import floorPlanHelpers from '../mixins/floorPlanHelpers'
import floorPlanTimeHelpers from '../mixins/floorPlanTimeHelpers'
import TableCard from './TableCard'
export default {
  name: 'ChangeTableExpanded',
  components: {TableCard},
  mixins: [floorPlanHelpers, floorPlanTimeHelpers],
  props: {
    value: {
      type: Array,
      default () {return []}
    },
    locationId: Number,
    reservationId: Number,
    reservationDateTime: String,
    tableConfigId: Number,
    date: String,
    time: [String, Number]
  },
  data () {
    return {
      tables: [],
      bookingsMap: [],
      allowSelectMultiple: false,
    }
  },
  computed: {
    filteredTables () {
      return this.tables.filter(t => t.name != this.value)
    },
    tableAssignmentsMap () {
      return this.value?.reduce((acc, r) => {
        acc[r.locationTableId] = true
        return acc
      }, {}) ?? {}
    }
  },
  mounted () {
    this.awaitingApiResponse = true
    this.$ftAPI().get(this.addResourceErrorHandler([
      {
        command: 'diningLocationTable',
        load: this.tables,
        afterLoad: () => this.awaitingApiResponse = false,
        error: () => this.awaitingApiResponse = false,
        params: {
          filter_methods: {
            filterByOnTableConfig: [this.tableConfigId],
            filterByShowOnFloorPlan: [true, this.tableConfigId],
          },
          filter: [{field: 'locationId', operator: 'EQUAL', values: [this.locationId]}]
        }
      },
      {
        command: 'diningGetTableBookings',
        load: r => this.bookingsMap = r?.[0].result,
        params: {
          filter_methods: {
            filterData: [this.reservationDateTime, this.locationId, this.reservationId]
          }
        }
      }
    ]))
    this.allowSelectMultiple = this.value.length > 1
  },
  methods: {
    /**
     * Use the selection status of the inputted table to determine the quantity assigned
     * @param {Object} table DiningLocationTable
     */
    getTableAssignments (table = {}) {
      let assignments = this.bookingsMap[table.id] ?? 0
      if (this.getTableSelected(table)) assignments += 1
      return assignments
    },
    /**
     * Use the `tableAssignmentsMap` to determine if the passed-in table is selected
     * @param {Object} table DiningLocationTable
     */
    getTableSelected (table = {}) {
      return !!this.tableAssignmentsMap[table.id]
    },
    selectTable (table) {
      let temp = [...this.value]
      if (this.tableAssignmentsMap[table.id]) {
        if (!this.allowSelectMultiple) return
        const spliceIndex = temp.findIndex(t => t.locationTableId === table.id)
        if (spliceIndex !== -1) {
          temp.splice(spliceIndex, 1)
          this.$emit('input', temp.map(t => {
            return {
              ...t,
              joined: temp.length > 1
            }
          }))
        }
      } else {
        if (!this.allowSelectMultiple) temp = []
        temp.push({
          reservationId: this.reservationId,
          locationTableId: table.id,
          locationTableName: table.name,
          quantity: 1,
          autoAssigned: false,
          joined: false,
          isPlaceholder: false,
        })
        this.$emit('input', temp.map(t => {
          return {
            ...t,
            joined: temp.length > 1
          }
        }))
      }
    }
  }
}
</script>
